import type { Slicers } from 'types/services';
import { SLICER_KEYS } from 'types/services';

export const selectOpened = (state: Slicers) => state[SLICER_KEYS.CHATBOT].open;
export const selectFullScreen = (state: Slicers) => state[SLICER_KEYS.CHATBOT].fullScreen;
export const selectSize = (state: Slicers) => state[SLICER_KEYS.CHATBOT].size;
export const selectHistory = (state: Slicers) => state[SLICER_KEYS.CHATBOT].history;
export const selectActiveHistoryId = (state: Slicers) => state[SLICER_KEYS.CHATBOT].activeHistoryId;
